export default __webpack_public_path__ + "static/media/John Pimentel.c21c28da.jpg";